/* eslint-disable */
// prettier-ignore-start
import logo from '../assets/images/national-highways-logo.svg';
import policeimg from '../assets/images/police_icon.svg';
import gritterimg from '../assets/images/gritter-icon.svg';
import sweeperimg from '../assets/images/road_sweeper.svg';
import recoveryimg from '../assets/images/recovery_icon.svg';
import ambulanceimg from '../assets/images/ambulance_icon.svg';
import fireimg from '../assets/images/fireEngine_icon.svg';
import trafficofficerimg from '../assets/images/traffic_officer.svg';
import helicopterimg from '../assets/images/helicopter_icon.svg';
import bikeImg from '../assets/images/bike_icon.svg';
import busImg from '../assets/images/bus_icon.svg';
import carImg from '../assets/images/car_icon.svg';
import caravanImg from '../assets/images/caravan_icon.svg';
import hgvImg from '../assets/images/hgv_icon.svg';
import horseBoxImg from '../assets/images/horse_box_icon.svg';
import trailerImg from '../assets/images/trailer_icon.svg';
import vanImg from '../assets/images/van_icon.svg';
import { faSignOutAlt, faUser } from '@fortawesome/free-solid-svg-icons';
import HomeIcon from '../assets/images/home.svg';
import SettingsIcon from '../assets/images/settings.svg';
import DownloadsIcon from '../assets/images/downloads.svg';
import CommentIcon from '../assets/images/comment-dots.svg';
import Road from '../assets/images/Road.png';
import Light from '../assets/images/Light.png';
import Colour from '../assets/images/Colour.png';
import Greyscale from '../assets/images/Greyscale.png';
import Satellite from '../assets/images/Satellite.png';
import Bridge from '../assets/images/bridge_icon.png';
import Tunnel from '../assets/images/tunnel_icon.png';
import MarkerPost from '../assets/images/marker-post-icon.png';

export const routeContants = {
  homeUrl: '/',
  rootUrl: '/',
  operatorInterfaceUrl: '/operator',
};

export const headerConstants = {
  refreshText: 'Traffic information updated less than 1 min ago',
  refereshTextMobile: 'Traffic info updated less than 1 min ago',
  brandText: '',
  operatorInterfaceHeaderText: 'Operator Interface',
  brandLogoText: 'National Highways Logo',
  brandLogoWidth: 'auto',
  brandLogoHeight: '40',
  brandLogoUrl: '/map',
  brandLogo: logo,
  operatorInterfaceMenuArray: [
    {
      label: 'Map',
      href: '/operator',
    },
    {
      label: 'Create Event',
      href: '/operator/create-event',
    },
  ],
  menuArray: [
    {
      label: 'Map',
      href: '/map',
      navTabIndex: '3',
    },
    {
      label: 'Travel Alerts',
      href: 'https://highwaysengland.co.uk/travel-updates/travel-alerts/',
      target: '_blank',
      navTabIndex: '4',
    },
    {
      label: 'Subscriber Data Feed',
      href: '/subscriberportal',
      navTabIndex: '5',
    },
  ],
  feedbackArray: [
    {
      label: 'Feedback',
      href: 'https://nationalhighways.co.uk/travel-updates/traffic-england-feedback-form/',
      target: '_blank',
    },
  ],
  thirdPartyPopupBodyProps: {
    popupTitle: '3rd Party Links',
    popupBody:
      'This link will lead you to a 3rd party website. We do not control the content on the website you are trying to visit.',
    popupConsent: 'Do you still wish to continue?',
    popupRememberMe: 'Do not show me this message again',
  },
};

export const deletePopupConstants = (
  openThirdPrtyLink: any,
  onHomeClick: any,
) => ({
  brandLogo: logo,
  thirdPartyPopupBodyProps: {
    popupTitle: 'Your account has been closed',
    popupBody:
      'All of your data has now been removed from our system, you will not receive any more correspondence from us. We hope you enjoyed our features while you were here!',

    popupConsent:
      'You can send Feedback on your experience here, otherwise you’ll be redirected back to the home page',
    primaryButtonLabel: 'Home',
    secondaryButtonLabel: 'Feedback',
    handlePrimaryButton: onHomeClick,
    handleSecondaryButton: openThirdPrtyLink,
  },
});

export const footerConstants = {
  footerLinks: [
    { name: 'Cookies', url: '/cookies', linkTabIndex: 13 },
    { name: 'Privacy Notice', 
      // url: '/privacy-notice',
      url: 'https://nationalhighways.co.uk/about-us/privacy-notice/',
      linkTabIndex: 14,
      target:'self'
 },
    {
      name: 'Terms & Conditions',
      // url: '/terms-and-conditions',
      url: 'https://nationalhighways.co.uk/about-us/terms-and-conditions/',
      linkTabIndex: 15,
      target:'self'
    },
    // { name: 'FAQs', url: '/faqs', linkTabIndex: 16 },
  ],
  brandLogoUrl: '/map',
};

export const mapConstants = {
  mapInit: {
    center: [-1.9591947375679695, 52.46891727965905],
    zoom: 4,
    view: 'auto',
    boundingBox: [-6.0, 49.959999905, 1.9, 58.6350001085],
    osBoundingBox: [-10.76418, 49.528423, 1.9, 61.331151],
    osMapZoomLimit: 14,
    countrySet: 'en-GB',
    baseStyle: 'blank',
  },
  stylePicker: [
    { id: 1, style: 'blank' },
    { id: 2, style: 'blank' },
    { id: 3, style: 'road' },
    { id: 4, style: 'grayscale_light' },
    { id: 5, style: 'satellite_road_labels' },
  ],
  failureTestParams: {
    osMap: '/7/63/41.png?key=',
    default: '&zoom=6&x=30&y=21&subscription-key=',
    satellite: '&zoom=6&x=30&y=21&billing=hybrid-vector&subscription-key=',
  },
  zoomOutLimit: 5,
  homeCenter: [-2.0654296874940883, 53.144081881251],
  homeBoundingBox: [
    -16.127929687493946, 50.00485819443128, 11.997070312506196,
    56.069533567451174,
  ],
  tileSizeOSMap: 180,
  networkBlueColor: '#1432b9',
  networkYellowColor: '#f9da42',
  fontBlueColor: '#021f40',
  font: 'SegoeFrutigerHelveticaMYingHei-Regular',
  rotationAlignment: 'viewport',
  linksWidth: 4,
  trafficLinksWidth: 5,
  trafficKeyColors: {
    black: '#000000',
    red: '#d4351c',
    amber: '#fd0',
    green: '#00703c',
  },
  legendIndicators: [
    {
      tag: 'Closed',
      color: 'indicator-gradient',
    },
    {
      tag: 'Not moving',
      color: '#000',
    },
    {
      tag: '   ',
      color: '#d4351c',
    },
    {
      tag: '   ',
      color: '#fd0',
    },
    {
      tag: 'Moving freely',
      color: '#00703c',
    },
  ],
  polygonData: {
    tflCoordinates: [-0.03929796538773189, 51.337549103844566],
    twCoordinates: [-3.595520828989578, 51.93399583312183],
    tsCoordinates: [-2.8226866545924736, 55.38449751369663],
  },
  errorCodes: [400, 401, 403, 404, 500],
  LayerSelectorContentHeader: ['Basemaps', 'Assets'],
  imgArray: {
    baseMaps: [
      { img: Light, label: 'Light' },
      { img: Road, label: 'Road' },
      { img: Colour, label: 'Colour' },
      { img: Greyscale, label: 'Greyscale' },
      { img: Satellite, label: 'Satellite' },
    ],
    assets: [
      { img: Bridge, label: 'Bridges' },
      { img: MarkerPost, label: 'Marker Posts' },
      { img: Tunnel, label: 'Tunnels' },
    ],
  },
  searchFilters: [
    {
      name: 'Road Name',
      value: '1',
      isDefault: true,
    },
    {
      name: 'Junction Name',
      value: '2',
      isDefault: true,
    },
    {
      name: 'Marker Posts',
      value: '3',
      isDefault: true,
    },
    {
      name: 'CCTV',
      value: '4',
      isDefault: true,
    },
    {
      name: 'Filter option 5',
      value: '5',
      isDefault: false,
    },
    {
      name: 'Filter option 6',
      value: '6',
      isDefault: false,
    },
    {
      name: 'Filter option 7',
      value: '7',
      isDefault: false,
    },
    {
      name: 'Filter option 8',
      value: '8',
      isDefault: false,
    },
    {
      name: 'Filter option 9',
      value: '9',
      isDefault: false,
    },
    {
      name: 'Filter option 10',
      value: '10',
      isDefault: false,
    },
    {
      name: 'Filter option 11',
      value: '11',
      isDefault: false,
    },
    {
      name: 'Filter option 12',
      value: '12',
      isDefault: false,
    },
    {
      name: 'Filter option 13',
      value: '13',
      isDefault: false,
    },
  ],
};

export const hyperLinks = {
  privacyNoticeLink: 'https://highwaysengland.co.uk/about-us/privacy-notice/',
  subscribersLink: 'https://www.trafficengland.com/subscribers',
  subscriberSupportMailLink: 'subscribersupport@nisjv.com',
  ukGovLicenseLink:
    'https://www.nationalarchives.gov.uk/doc/open-government-licence/version/2/',
  ukGovDataLink: 'https://www.data.gov.uk',
  cookiesPolicy: '/cookies',
};

export const breadcrumbsLinks = {
  cookiesPolicy: [
    { name: 'Home', url: '/' },
    { name: 'Cookies', url: '' },
  ],
  faqs: [
    { name: 'Home', url: '/' },
    { name: 'FAQs', url: '' },
  ],
  privacyNotice: [
    { name: 'Home', url: '/' },
    { name: 'Privacy Notice', url: '' },
  ],
  termsAndConditions: [
    { name: 'Home', url: '/' },
    { name: 'Terms & Conditions', url: '' },
  ],
  accountManagement: [
    { name: 'Home', url: '/' },
    { name: 'Account Management', url: '' },
  ],
  deleteAccount: [
    { name: 'Home', url: '/' },
    { name: 'Account Management', url: '/accountManagement' },
    { name: 'Delete Account', url: '' },
  ],

  NTISDataFeeds: [
    { name: 'Home', url: '/subscriberportal' },
    { name: 'NTIS Data Feeds', url: '' },
  ],
  downloads: [
    { name: 'Home', url: '/subscriberportal' },
    { name: 'Downloads', url: '' },
  ],
  contact: [
    { name: 'Home', url: '/subscriberportal' },
    { name: 'Contact', url: '' },
  ],
  availableSubscriberFeed: [
    { name: 'Home', url: '/subscriberportal' },
    { name: 'NTIS Data Feeds', url: '/subscriberportal/subscriberdatafeed' },
    {
      name: 'Available Data Feeds',
      url: '',
    },
  ],
  editSubscriberFeed: [
    { name: 'Home', url: '/subscriberportal' },
    { name: 'NTIS Data Feeds', url: '/subscriberportal/subscriberdatafeed' },
  ],
  configureSubscriberFeed: [
    { name: 'Home', url: '/subscriberportal' },
    { name: 'NTIS Data Feeds', url: '/subscriberportal/subscriberdatafeed' },
    {
      name: 'Available Data Feeds',
      url: '/subscriberportal/availabledatafeed',
    },
  ],
};

export const EventServiceTypes = [
  {
    servicestype: [
      {
        name: 'Traffic Officers',
        value: 'f545abb9-7ad6-4f5b-bfb8-1e249c06d6a5',
        dropdown: false,
        dropwDownValues: [],
        icon: trafficofficerimg,
      },
      {
        name: 'Police',
        value: '2e9b567b-2c23-4ec0-905d-1dea84f1d866',
        dropdown: false,
        dropwDownValues: [],
        icon: policeimg,
      },
      {
        name: 'Ambulance',
        value: 'e88c2333-0089-44f0-9feb-53865a28ab34',
        dropdown: false,
        dropwDownValues: [],
        icon: ambulanceimg,
      },
      {
        name: 'Fire',
        value: '458e9567-e81e-4388-9d5d-2b117ad516e6',
        dropdown: false,
        dropwDownValues: [],
        icon: fireimg,
      },
    ],
  },
  {
    servicestype: [
      {
        name: 'Air ambulance',
        value: '6855d69c-9607-4123-ace2-4de6ef6a0083',
        dropdown: false,
        dropwDownValues: [],
        icon: helicopterimg,
      },
      {
        name: 'Recovery',
        value: 'bb648030-f118-4e68-8fe6-822b6c9d6fbe',
        dropdown: false,
        dropwDownValues: [],
        icon: recoveryimg,
      },
      {
        name: 'Sweeper',
        value: '8d1e22e2-688f-4b9a-ab62-d5c9fe995679',
        dropdown: false,
        dropwDownValues: [],
        icon: sweeperimg,
      },
      {
        name: 'Gritter',
        value: 'e9e6ee56-d86e-4760-9c71-7de31bf62479',
        dropdown: false,
        dropwDownValues: [],
        icon: gritterimg,
      },
    ],
  },
  {
    servicestype: [
      {
        name: 'Cleaning',
        value: 'cleaning',
        dropdown: true,
        dropwDownValues: [
          {
            name: 'Specialist cleaning',
            value: '780bf7f9-35b7-4313-b4d5-f2a9c03bff02',
            type: 'cleaning',
          },
          {
            name: 'Hydro blaster',
            value: '226da6e9-806d-478f-9760-47eaa888e109',
            type: 'cleaning',
          },
        ],
        icon: '',
      },
      {
        name: 'Support',
        value: 'support',
        dropdown: true,
        dropwDownValues: [
          {
            name: 'ISU',
            value: 'b1f0b6a9-4e15-4caf-94bc-ee66d88a0b3d',
            type: 'support',
          },
          {
            name: 'Barrier crew',
            value: '8700056b-f21b-46c6-9799-3a82dc3f5390',
            type: 'support',
          },
          {
            name: 'Bridge inspector',
            value: '59944fcb-ccd4-4894-a8c2-bcec586b46f5',
            type: 'support',
          },
          {
            name: 'Other',
            value: 'f76eafad-3dc3-4bae-8f1d-5f8ba6f218ff',
            type: 'support',
          },
        ],
        icon: '',
      },
    ],
  },
];

export const vehicles = [
  {
    vehiclestype: [
      {
        name: 'Car',
        id: '72dca201-7d0a-4757-89b8-0b989b94c65b',
        icon: carImg,
      },
      {
        name: 'HGV',
        id: '4d8b6ce0-e0a1-49ba-9d7b-489f0981a34b',
        icon: hgvImg,
      },
      {
        name: 'Van',
        id: '42028404-4b0a-4151-b1b6-562d5036ab8e',
        icon: vanImg,
      },
      {
        name: 'Bike',
        id: 'db670cbf-27cb-4c3f-a0e4-862204e3e0ff',
        icon: bikeImg,
      },
    ],
  },
  {
    vehiclestype: [
      {
        name: 'Trailer',
        id: 'ae200ce2-e922-4445-b0c1-68931c6f18d5',
        icon: trailerImg,
      },
      {
        name: 'HorseBox',
        id: 'f93652b0-58be-4577-b4d0-ac08ab3e0674',
        icon: horseBoxImg,
      },
      {
        name: 'Caravan',
        id: 'b153bb20-ddfb-42b9-aa7a-816a6a9174e4',
        icon: caravanImg,
      },
      {
        name: 'Bus',
        id: 'e8245d3f-4723-4f1c-94a5-a0c925046fcc',
        icon: busImg,
      },
    ],
  },
  {
    vehiclestype: [
      {
        name: 'Abnormal Load',
        id: '47f09789-2948-49ef-9d78-ebd10df7afe9',
        icon: null,
      },
      {
        name: 'Other',
        id: '172c5409-19fa-4273-906c-b0f9b5621784',
        icon: null,
      },
    ],
  },
];

export const EventHighPriority = [
  {
    name: 'SL',
    value: 'b4904466-9c61-4eea-9fe7-ddb32ac76460',
    icon: '',
  },
  {
    name: 'NNM',
    value: '24f885ec-06d8-4964-b725-2706d42717d8',
    icon: '',
  },
  {
    name: 'NILO',
    value: '1d216745-54f1-463d-81b7-4f182d0686a4',
    icon: '',
  },
];

export const AccountManagementConstants = {
  pageHeader: 'Account Management',
  personalDetailsHeader: 'Personal Details',
  changePasswordHeader: 'Change Password',
  deleteAccountHeader: 'Delete Account',
  personalDetails: {
    emailAddress: 'Email Address',
    firstName: 'First Name',
    lastName: 'Last Name',
    companyName: 'Company Name',
    alternativeEmail: 'Alternative Email',
    emailAddressError: 'Please enter a valid email address',
    duplicateEmailAddressError:
      'Email already exists, please use a different email address',
    firstnameError: 'Please enter a name without numbers or invalid characters',
    lastnameError:
      'Please enter a last name without numbers or invalid characters',
    companyNameError: 'Please enter a valid company name',
    emailRulesStartText:
      'Email address should be 64 characters long and consist of:',
    emailRulesCharacters:
      'Uppercase and lowercase letters in English (A-Z, a-z)',
    emailRulesDigitText: 'Digits from 0 to 9',
    emailRulesSpecialText:
      'Special characters such as ! # $ % & * + - / = ? ^ _ ` { |',
  },
  changePasswordSection: {
    oldPassword: 'Old Password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    oldPasswordPlaceholder: '**********',
    passwordRulesStartText: 'Password must contain:',
    passwordRulesCharacters: 'A minimum 8 characters',
    passwordRulesConditionText: 'At least 3 of the following',
    passwordRulesLowercase: 'Lowercase',
    passwordRulesUppercase: 'Uppercase',
    passwordRulesNumbers: 'Numbers',
    passwordRulesSymbols: 'Symbols (@#$%)',
    passwordRulesRecommendation:
      'We recommend using a password generator for a secure password',
  },
  deleteAccount: {
    deleteDescription:
      'Any personal information stored by us will be permanently deleted when you delete your account. As a result of this, you will lose access to features requiring this information such as saved routes, any personalisations, data subscriptions and downloads.',
    deleteConfirm: 'Are you sure you wish to delete your account?',
    deleteButtonText: 'Continue to Account Deletion',
    confirmDeleteButtonText: 'Yes, I wish to delete my account',
    deleteAccountConfirmationText:
      'I confirm I understand that deleting my account means all my data will be removed and I will no longer have access to my account or data subscription',
    editPreDescription:
      'If you’re looking to change your details instead you can use the ',
    editLinkDescription: 'account management',
    editPostDescription: ' page to do so.',
    deleteDescriptionDetails:
      'By deleting your account your information will immediately be removed and you will lose access to the following features:',
    deleteDescriptionDetailsList: [
      'Saved routes',
      'Personalisation and alerts',
      'Data subscriptions',
      'And others',
    ],
  },
};

export const sideMenuButtonArray = [
  {
    iconName: faUser,
    label: 'Profile',
  },
  {
    iconName: faSignOutAlt,
    label: 'Logout',
  },
];

export const subscriberPortalnavLinks = [
  {
    url: '/subscriberportal',
    label: 'Welcome',
    ariaLabel: 'House Icon',
    parent: 'welcome',
    icon: HomeIcon,
    submenus: [
      {
        url: '/subscriberportal/howitworks',
        label: 'How it works',
        parent: 'welcome',
      },
      // {
      //   url: '/subscriberportal/howtoconfigure',
      //   label: 'How to configure',
      //   parent: 'welcome',
      // },
      {
        url: '/subscriberportal/availablefeed',
        label: 'Available feeds',
        parent: 'welcome',
      },
      // {
      //   url: '/subscriberportal/help',
      //   label: 'Help',
      //   parent: 'welcome',
      // },
    ],
  },
  {
    url: '/subscriberportal/subscriberdatafeed',
    label: 'NTIS Traffic Data',
    ariaLabel: 'NTIS Traffic data icon',
    parent: 'pushdatafeed',
    icon: SettingsIcon,
  },
  {
    url: '/subscriberportal/pullfeeds',
    label: 'Downloads',
    ariaLabel: 'Download icon',
    parent: 'pulldatafeed',
    icon: DownloadsIcon,
  },
  {
    url: '/subscriberportal/contactus',
    label: 'Contact',
    ariaLabel: 'Feedback icon',
    parent: 'feedback',
    icon: CommentIcon,
  },
];

export const cookiesConstants = {
  ntisWebCookieKey: 'NTIS-Web-Cookie',
  ntisAcceptWebCookieValue: 'Accepted NTIS terms and conditions',
  ntisAddDataFeedCookieKey: 'NTIS-Add-Data-Feed-Cookie',
  ntisAddDataFeedCookieValue:
    'Accepted use and operational policy for NTIS Traffic Data',
  expiryDate: 'Thu, 01 Jan 9999 00:00:01 GMT',
};

export const sessionConstants = {
  ntisWebDeclineCookieSessionKey: 'NTIS-Web-Decline-Cookie',
  ntisWebDeclineCookieSessionValue: 'Declined NTIS terms and conditions',
};

export const confirmationSteps = [
  {
    step: 1,
    stepHeading: 'Confirm Subscription',
  },
  {
    step: 2,
    stepHeading: 'Confirmation',
  },
];

export const clearEventInformationSourceOptions = ['NILO', 'ROC', 'Other'];

export const failureIcon =
  'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjkiIGhlaWdodD0iMjkiIHZpZXdCb3g9IjAgMCAyOSAyOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCiAgICA8cGF0aCBkPSJNMjkgMTQuNUMyOSAyMi41MSAyMi41MDggMjkgMTQuNSAyOVMwIDIyLjUxIDAgMTQuNUMwIDYuNDk1IDYuNDkyIDAgMTQuNSAwUzI5IDYuNDk1IDI5IDE0LjV6bS0xNC41IDIuOTIzYTIuNjkgMi42OSAwIDEgMCAwIDUuMzggMi42OSAyLjY5IDAgMCAwIDAtNS4zOHptLTIuNTUzLTkuNjY3LjQzMyA3Ljk1MmMuMDIuMzcyLjMyOC42NjMuNy42NjNoMi44NGMuMzcyIDAgLjY4LS4yOTEuNy0uNjYzbC40MzMtNy45NTJhLjcwMi43MDIgMCAwIDAtLjctLjc0aC0zLjcwNmEuNzAyLjcwMiAwIDAgMC0uNy43NHoiIGZpbGw9IiNmZmYiLz4NCjwvc3ZnPg0K';

export const successIcon =
  'data:image/svg+xml;base64,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';
export const errorMessages = {
  deleteAccountErrorMessage:
    'There’s been an error deleting your account. Please try again.',
  civilAssetUploadErrorMessage:
    'There was an error attempting to upload the selected CSV file. Please try again.',
};
